module.exports = __webpack_public_path__ + "static/media/Mapa-Distrito Federal.e8c40cdc.svg";